/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_UpdatingInputs */

const en_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating API Key. Please wait...`)
};

const fr_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour de la clé API. Veuillez patienter...`)
};

const de_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Schlüssel wird aktualisiert. Bitte warten...`)
};

const it_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento della chiave API. Attendi...`)
};

const ru_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновление ключа API. Пожалуйста, подождите...`)
};

const es_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizando clave API. Espere...`)
};

const zh_cn2_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在更新 API 密钥。请稍候……`)
};

const ja_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`APIキーを更新しています。お待ちください...`)
};

const hi_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एपीआई कुंजी अपडेट की जा रही है। कृपया प्रतीक्षा करें...`)
};

const pt_pt2_options_api_keys_updating = /** @type {(inputs: Options_Api_Keys_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizando a chave da API. Aguarde...`)
};

/**
* | output |
* | --- |
* | "Updating API Key. Please wait..." |
*
* @param {Options_Api_Keys_UpdatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_updating = /** @type {((inputs?: Options_Api_Keys_UpdatingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_UpdatingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_updating(inputs)
	if (locale === "de") return de_options_api_keys_updating(inputs)
	if (locale === "it") return it_options_api_keys_updating(inputs)
	if (locale === "ru") return ru_options_api_keys_updating(inputs)
	if (locale === "es") return es_options_api_keys_updating(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_updating(inputs)
	if (locale === "ja") return ja_options_api_keys_updating(inputs)
	if (locale === "hi") return hi_options_api_keys_updating(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_updating(inputs)
	return en_options_api_keys_updating(inputs)
});